import { render } from "./NewCardProductItem.vue?vue&type=template&id=4b04e663&scoped=true"
import script from "./NewCardProductItem.vue?vue&type=script&lang=js"
export * from "./NewCardProductItem.vue?vue&type=script&lang=js"

import "./NewCardProductItem.vue?vue&type=style&index=0&id=4b04e663&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b04e663"]])

export default __exports__